import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { showOrganisationalUnitLogoImageModal } from '../../../../actions/modal';

import Info from '../../info';

export default function RightPanelUpdate(props) {
  const dispatch = useDispatch();

  const [isSaving, setIsSaving] = useState(false);
  const globalMessageData = useSelector((state) => state.globalMessageReducer.messageData);

  const LogoImageUpdate = (e) => {
    setIsSaving(true);
    props.saveLogoPauseImage();
  };

  const cancelUpdateLogoPauseImage = () => {
    if (globalMessageData) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(showOrganisationalUnitLogoImageModal(false));
  };

  const saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white max-width left-text mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl max-width mrtxxs">
        <div data-show={!props.readOnly}>
          <button
            tabIndex="4"
            type="button"
            onClick={LogoImageUpdate}
            className={isSaving ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateLogoPauseImage}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
        <div data-show={props.readOnly}>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateLogoPauseImage}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      </div>
      <div>
        <Info paragraphs={[APP.LANGUAGE.DefaultOrgLogo.Help1]} />
        <ul>
          <li className="mrtxs color-white-mobile-tablet">{APP.LANGUAGE.DefaultOrgLogo.Help2}</li>
          <li className="mrtxs color-white-mobile-tablet">{APP.LANGUAGE.DefaultOrgLogo.Help3}</li>
          <li className="mrtxs color-white-mobile-tablet">{APP.LANGUAGE.DefaultOrgLogo.Help4}</li>
        </ul>
      </div>
    </div>
  );
}
